import { UI } from "@wwimmo/ui";
import styles from "./AgendaItemDocumentsListItem.module.css";
import { ColorStyle } from "src/utils/Colors";

interface AgendaItemDocumentsListItemProps {
    fileId?: any;
    fileName?: string;
    fileLink: string;
    additionalIcon: any;
}

export const AgendaItemDocumentsListItem = (props: AgendaItemDocumentsListItemProps) => {
    const { fileId, fileName, fileLink, additionalIcon } = props;

    return (
        <div className={styles.ListItem} key={fileId}>
            <a href={fileLink} className={styles.DocumentInfoItemsContainer} rel="noopener noreferrer" target="_blank">
                <UI.Icon icon={UI.SVGIcon.Documents} color={ColorStyle("primary")} size={26} />
                <div className={styles.FileDetailsRow}>
                    <div className={styles.FileName}>{fileName}</div>
                </div>
            </a>
            <div className={styles.AdditionalIcon}>{additionalIcon}</div>
        </div>
    );
};
